<div class="tinymce-editor-wrapper">
  <editor
    [apiKey]="tinyMceApiKey"
    [ngModel]="editorContent"
    (ngModelChange)="editorData($event)"
    [init]="editorConfig"
    [readonly]="disabled"
    (onBlur)="onBlur($event)"
  ></editor>
</div>
